import { all } from "redux-saga/effects"
import { authSaga } from "./authSaga"
import { categorySourceSaga } from "./categorySourceSagas"
import { appConfigSaga } from "./common/appConfigSaga"
import { dictionarySaga } from "./dictionarySagas"
import { localizedResourceSaga } from "./localized-resource/localizedResourcsSaga"
import { notifySaga } from "./notify/notifySaga"
import { foCaAnSaga } from "./thuc-don/foCaAnSaga"
import { foCaAnTruongSaga } from "./thuc-don/foCaAnTruongSaga"
import { foMonAnChiTietSaga } from "./thuc-don/foMonAnChiTietSaga"
import { foThucDonSaga } from "./thuc-don/foThucDonSaga"
import { foDotDangKyAnSaga } from "./thuc-don/foDotDangKyAnSaga"
import { foDotDangKyPhamViSaga } from "./thuc-don/foDotDangKyPhamViSaga"
import { foDangKyAnHocSinhSaga } from "./thuc-don/foDangKyAnHocSinhSaga"
import { hocSinhViewShortSaga } from "./thuc-don/hocSinhViewShortSaga"
import { uploadSaga } from "./upload-file/uploadSaga"
import { lopSaga } from "./danh-muc/lopSaga"
import { ngayNghiSaga } from "./danh-muc/ngayNghiSaga"
import { trangThaiDangKyAnSaga } from "./danh-muc/trangThaiDangKyAnSaga"

export default function* rootSaga() {
  yield all([
    authSaga(),
    dictionarySaga(),
    categorySourceSaga(),
    uploadSaga(),
    notifySaga(),
    localizedResourceSaga(),
    appConfigSaga(),
    foCaAnSaga(),
    foCaAnTruongSaga(),
    foMonAnChiTietSaga(),
    foThucDonSaga(),
    foDotDangKyAnSaga(),
    foDotDangKyPhamViSaga(),
    foDangKyAnHocSinhSaga(),
    hocSinhViewShortSaga(),
    lopSaga(),
    ngayNghiSaga(),
    trangThaiDangKyAnSaga(),
  ]);
}
